import { IBatchState, IActionBase } from "../models/root.interface";
import { ADD_BATCH, CLEAR_BATCHES } from "../actions/batches.action";


const initialState: IBatchState = {
    batch: [{ id: 1, name: "Batch 1", contactsNo: 4000, scheduleTime: "22 July 2019", status: 3 },
    { id: 2, name: "Batch 1", contactsNo: 4000, scheduleTime: "22 July 2019", status: 3 },
    { id: 3, name: "Batch 1", contactsNo: 4000, scheduleTime: "22 July 2019", status: 3 }
    ]
};
function BatchReducer(state: IBatchState = initialState, action: IActionBase): IBatchState {
    switch (action.type) {
        case ADD_BATCH: {
            let maxId: number = Math.max.apply(Math, state.batch.map(o => o.id));
            if (maxId === -Infinity) { maxId = 0; }
            let newItem = {
                id: maxId + 1,
                name: action.name,
                contactsNo: action.contactsNo,
                scheduleTime: action.scheduleTime,
                status: action.status,
            };
            return { ...state, batch: [...state.batch, newItem] };
        }
        case CLEAR_BATCHES:
            return { ...state, batch: [] };
        default:
            return state;
    }
}


export default BatchReducer;